import { IN_APP_BROWSER_UA } from '../common/constants/inAppBrowser';
import type { NavigatorWithModel } from '../interfaces/userAgent.interface';

export function isPixelFacebook(userAgent: string, model = ''): boolean {
  return IN_APP_BROWSER_UA.ANDROID.test(userAgent.toLowerCase())
    && IN_APP_BROWSER_UA.FACEBOOK.test(userAgent)
    && IN_APP_BROWSER_UA.PIXEL.test(model || userAgent);
}

export async function getDeviceModel(navigator: NavigatorWithModel): Promise<string> {
  try {
    const hints = await navigator.userAgentData?.getHighEntropyValues(['model']);
    return hints?.model ?? '';
  } catch {
    return '';
  }
}
